
import React, { useEffect } from 'react';
import MatrixBackground from '../components/MatrixBackground';
import ScanLines from '../components/ScanLines';
import Header from '../components/Header';
import About from '../components/About';
import Footer from '../components/Footer';

const AboutPage = () => {
  useEffect(() => {
    // Change title
    document.title = 'About | SpecialAgentK';
  }, []);

  return (
    <div className="bg-cyber-black text-cyber-green min-h-screen">
      <MatrixBackground />
      <ScanLines />
      <Header />
      <div className="pt-28">
        <About />
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
